export default __webpack_public_path__ + "46afc2042fc5bbe0562604419fb30cef.svg";